<template>
 <div>
  <audit-flow-manage />
 </div>
</template>

<script>
import auditFlowManage from '../auditFlowManage'

export default {
  components: {
    auditFlowManage,
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped lang='scss'>

</style>
